import { v4 as uuid } from 'uuid'

/**
 * 生成播放会话 traceId：uuid_北京时间(YYYYMMDDHHmmss)
 * 时间统一转换为北京时间(UTC+8)，不受本地时区影响。
 */
export function genPlayTraceId(): string {
  // epoch 毫秒 + 8 小时，再读取 UTC 字段，即为北京时间各分量
  const beijing = new Date(Date.now() + 8 * 60 * 60 * 1000)
  const pad = (n: number) => String(n).padStart(2, '0')
  const ts
    = beijing.getUTCFullYear().toString()
    + pad(beijing.getUTCMonth() + 1)
    + pad(beijing.getUTCDate())
    + pad(beijing.getUTCHours())
    + pad(beijing.getUTCMinutes())
    + pad(beijing.getUTCSeconds())
  return `${uuid()}_${ts}`
}
